// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2530": "e96a97f9","5150": "2fad77df","7053": "6afc9d1a","8561": "f9cad78a","9988": "01570931",}[chunkId] + ".css"
}